(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[27265,15805,93812,3536,34190,98162],{

/***/ 16921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Cards_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./UI/containers/CardContainer/index.jsx + 1 modules
var CardContainer = __webpack_require__(35565);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Cards/Card/Card.module.scss
var Card_module = __webpack_require__(93856);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ./UI/components/Cards/Card/utils/useCard.jsx








/* harmony default export */ function useCard(_param) {
    var url = _param.url, classes = _param.className, withoutBackground = _param.withoutBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "url",
        "className",
        "withoutBackground"
    ]);
    var Wrapper = url ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(_param) /*#__PURE__*/ {
        var path = _param.path, className = _param.className, imagesBundles = _param.imagesBundles, restWrapper = (0,_object_without_properties/* default */.Z)(_param, [
            "path",
            "className",
            "imagesBundles"
        ]);
        return (0,jsx_runtime.jsx)(react.Fragment, (0,_object_spread/* default */.Z)({}, restWrapper));
    };
    var _obj;
    var className = classnames_default()((Card_module_default()).card, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Card_module_default()).withoutBackground, withoutBackground), (0,_define_property/* default */.Z)(_obj, (Card_module_default()).withLink, url), _obj));
    return (0,_object_spread/* default */.Z)({
        Wrapper: Wrapper,
        className: className,
        withoutBackground: withoutBackground,
        path: url
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Cards/Card/index.jsx













var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    },
    ssr: false
});
var Card = function(props) {
    var _ref = useCard(props), Wrapper = _ref.Wrapper, icon = _ref.icon, title = _ref.title, text = _ref.text, children = _ref.children, className = _ref.className, image = _ref.image, withoutBackground = _ref.withoutBackground, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "Wrapper",
        "icon",
        "title",
        "text",
        "children",
        "className",
        "image",
        "withoutBackground"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer/* default */.Z, {
            className: className,
            noBackground: withoutBackground,
            children: [
                !!(image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    className: (Card_module_default()).image,
                    src: image.url,
                    alt: image.alt,
                    transparent: true
                }),
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: icon,
                    className: (Card_module_default()).icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Card_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            variant: useTypography/* TYPOGRAPHY_TAGS.h3 */.w1.h3,
                            size: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                            isBold: true,
                            className: (Card_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Card_module_default()).cardContent,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                document: text
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-read-more": true,
                            className: (Card_module_default()).readMore,
                            children: "Read more"
                        })
                    ]
                }),
                children
            ]
        })
    }));
};
Card.propTypes = {
    icon: (prop_types_default()).string,
    title: (prop_types_default()).string,
    text: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    className: (prop_types_default()).string,
    image: prop_types_default().instanceOf(Object),
    withoutBackground: (prop_types_default()).bool
};
/* harmony default export */ var Cards_Card = (Card);


/***/ }),

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 45783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getContentfulImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);


var getContentfulImage = function(_param) {
    var src = _param.src, width = _param.width, quality = _param.quality, progressive = _param.progressive, format = _param.format, transparent = _param.transparent, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "quality",
        "progressive",
        "format",
        "transparent"
    ]);
    try {
        var url = new URL(src);
        var fm = format || (transparent ? "webp" : "jpg");
        if (!format && src.includes(".svg")) {
            fm = null;
        }
        if (fm === "jpg") {
            fm = "webp";
        }
        fm && url.searchParams.set("fm", fm);
        width && url.searchParams.set("w", width);
        quality && url.searchParams.set("q", quality);
        Object.entries(params).forEach(function(param) {
            var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _$_param[0], value = _$_param[1];
            return key && value && url.searchParams.set(key, value);
        });
        return url.href;
    } catch (e) {
        return src;
    }
};


/***/ }),

/***/ 34190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Media; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Media/utils/helpers.js
var videoFormats = function(format) {
    return [
        "video/mp4",
        "video/webm", 
    ].includes(format);
};

;// CONCATENATED MODULE: ./UI/components/Media/utils/useMediaProps.js







/* harmony default export */ function useMediaProps(_param) {
    var asset = _param.asset, className = _param.className, isStatic = _param.isStatic, transparent = _param.transparent, loaderParams = _param.loaderParams, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "asset",
        "className",
        "isStatic",
        "transparent",
        "loaderParams"
    ]);
    var ref = (0,react.useRef)(null);
    var ref1 = get_default()(asset, "fields", {}), contentType = ref1.file.contentType;
    var isVideo = videoFormats(contentType);
    var ref2 = (0,helper/* getImage */.gJ)(asset), url = ref2.url, alt = ref2.alt;
    var imageProps = (0,_object_spread/* default */.Z)({
        alt: alt,
        src: url,
        layout: "fill",
        lazyBoundary: "700px",
        unoptimized: true,
        loader: isStatic ? function(param) {
            var src = param.src;
            return src;
        } : function(args) {
            return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
                transparent: transparent
            }, args, loaderParams));
        }
    }, rest);
    return (0,_object_spread/* default */.Z)({
        ref: ref,
        url: url,
        isVideo: isVideo,
        className: className,
        imageProps: imageProps
    }, rest);
};

// EXTERNAL MODULE: ./UI/components/Media/styles.module.scss
var styles_module = __webpack_require__(6992);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Media/index.jsx










var Media = function(props) {
    var _ref = useMediaProps(props), ref = _ref.ref, url = _ref.url, isVideo = _ref.isVideo, className = _ref.className, imageProps = _ref.imageProps, playControl = _ref.playControl, posterUrl = _ref.posterUrl, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref",
        "url",
        "isVideo",
        "className",
        "imageProps",
        "playControl",
        "posterUrl"
    ]);
    if (isVideo) {
        if (playControl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["video-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref,
                    controls: true,
                    poster: posterUrl,
                    className: className
                }, rest), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/mp4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/webm"
                        })
                    ]
                }))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            muted: true,
            autoPlay: true,
            loop: true,
            playsInline: true,
            className: className
        }, rest), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/webm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/mp4"
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()((styles_module_default()).image, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, imageProps))
    });
};
Media.propTypes = {
    asset: prop_types_default().instanceOf(Object).isRequired,
    autoPlay: (prop_types_default()).bool,
    loop: (prop_types_default()).bool,
    playsInline: (prop_types_default()).bool,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ])
};
/* harmony default export */ var components_Media = (Media);


/***/ }),

/***/ 15805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96076);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59654);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18422);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89494);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);










var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var SectionTitle = function(param) {
    var type = param.type, titleStyle = param.titleStyle, title = param.title, titleVariant = param.titleVariant, secondTitle = param.secondTitle, secondTitleVariant = param.secondTitleVariant, subtitle = param.subtitle, secondSubtitle = param.secondSubtitle, description = param.description, secondDescription = param.secondDescription, className = param.className, children = param.children;
    var titleSegments = title === null || title === void 0 ? void 0 : title.split("||");
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sectionTitleContainer), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[type], className, titleStyle),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-title": true,
                    isBold: true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                    mobileSize: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                    variant: titleVariant,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                    children: titleSegments.length === 1 ? title : titleSegments.map(function(segment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            "data-title": true,
                            isBold: true,
                            size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                            mobileSize: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                            variant: "span",
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                            children: segment
                        });
                    })
                })
            })),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-subtitle": true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                    children: subtitle
                })
            })),
            descriptionParagraphs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                        "data-description": true,
                        size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                        children: text
                    }, "paragraph/".concat(index));
                })
            })),
            secondTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 150,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    isBold: true,
                    "data-second-title": true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                    variant: secondTitleVariant,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                    children: secondTitle
                })
            })),
            secondSubtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-second-subtitle": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                    children: secondSubtitle
                })
            })),
            secondDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-second-description": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                    children: secondDescription
                })
            })),
            children
        ]
    });
};
SectionTitle.defaultProps = {
    type: "default",
    titleStyle: "",
    subtitle: "",
    description: null,
    className: null,
    title: null,
    secondTitle: "",
    secondSubtitle: "",
    secondDescription: "",
    titleVariant: "h2",
    secondTitleVariant: "h3"
};
SectionTitle.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    titleStyle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondTitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondSubtitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondDescription: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    titleVariant: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondTitleVariant: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (SectionTitle);


/***/ }),

/***/ 35565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_CardContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/CardContainer/CardContainer.module.scss
var CardContainer_module = __webpack_require__(14910);
var CardContainer_module_default = /*#__PURE__*/__webpack_require__.n(CardContainer_module);
;// CONCATENATED MODULE: ./UI/containers/CardContainer/utils/useCardContainer.js





/* harmony default export */ function useCardContainer(_param) {
    var children = _param.children, classes = _param.className, noBackground = _param.noBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "noBackground"
    ]);
    var className = classnames_default()((CardContainer_module_default()).cardContainer, classes, (0,_define_property/* default */.Z)({}, (CardContainer_module_default()).noBackground, noBackground));
    return (0,_object_spread/* default */.Z)({
        children: children,
        className: className
    }, rest);
};

;// CONCATENATED MODULE: ./UI/containers/CardContainer/index.jsx







var CardContainer = function(props, ref) {
    var _ref = useCardContainer(props), children = _ref.children, className = _ref.className, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        ref: ref
    }, restProps), {
        children: children
    }));
};
CardContainer.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBackground: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_CardContainer = (/*#__PURE__*/(0,react.forwardRef)(CardContainer));


/***/ }),

/***/ 27265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_CardsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/components/Cards/Card/index.jsx + 1 modules
var Card = __webpack_require__(16921);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/containers/Overlay/Overlay.module.scss
var Overlay_module = __webpack_require__(44291);
var Overlay_module_default = /*#__PURE__*/__webpack_require__.n(Overlay_module);
;// CONCATENATED MODULE: ./UI/containers/Overlay/utils/useOverlay.js




/* harmony default export */ function useOverlay(_param) {
    var classes = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var className = classnames_default()((Overlay_module_default()).overlay, classes);
    return (0,_object_spread/* default */.Z)({
        className: className
    }, props);
};

;// CONCATENATED MODULE: ./UI/containers/Overlay/index.jsx






var Overlay = function(props) {
    var _ref = useOverlay(props), className = _ref.className, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, restProps), {
        children: children
    }));
};
Overlay.propTypes = {
    children: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_Overlay = (Overlay);

// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./UI/sections/CardsSection/CardsSection.module.scss
var CardsSection_module = __webpack_require__(16161);
var CardsSection_module_default = /*#__PURE__*/__webpack_require__.n(CardsSection_module);
;// CONCATENATED MODULE: ./UI/sections/CardsSection/utils/useCardsSection.js















var _obj;
var SLIDES_PER_VIEW = (_obj = {}, (0,_define_property/* default */.Z)(_obj, routes/* routes.bookCall.slug */._.bookCall.slug, {
    thirdSectionView: "auto",
    fourthSectionView: "auto"
}), (0,_define_property/* default */.Z)(_obj, constants/* CASE_STUDIES.kitchenEquipment */.qU.kitchenEquipment, {
    firstSectionView: "auto"
}), (0,_define_property/* default */.Z)(_obj, constants/* CASE_STUDIES.aiPoweredComplianceTool */.qU.aiPoweredComplianceTool, {
    firstSectionView: "auto"
}), _obj);
var _obj1;
var SPACE_BETWEEN = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, routes/* routes.bookCall.slug */._.bookCall.slug, {
    thirdSectionView: 66,
    fourthSectionView: 43
}), (0,_define_property/* default */.Z)(_obj1, constants/* CASE_STUDIES.digitalWallet */.qU.digitalWallet, {
    firstSectionView: 16
}), _obj1);
var REWIND = (0,_define_property/* default */.Z)({}, routes/* routes.bookCall.slug */._.bookCall.slug, {
    firstSectionView: true,
    secondSectionView: true,
    thirdSectionView: true
});
var cardMapper = function() {
    return function(card) {
        var ref, ref1, ref2;
        if ((card === null || card === void 0 ? void 0 : (ref = card.sys) === null || ref === void 0 ? void 0 : (ref1 = ref.contentType) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) === "article") {
            var ref3 = (0,helper/* getDocumentFields */.OA)(card, [
                "title",
                "previewImageUrl",
                "slug", 
            ]), title = ref3.title, previewImageUrl = ref3.previewImageUrl, slug = ref3.slug;
            var image = (0,helper/* getImage */.gJ)(previewImageUrl);
            return {
                url: "".concat(constants/* PAGES.blog */.q5.blog, "/").concat(slug),
                image: image,
                title: title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Read more"
                })
            };
        }
        var _ref = (0,helper/* getDocumentFields */.OA)(card, [
            "title",
            "contentList",
            "text",
            "images",
            "imagesBundles",
            "contentModules", 
        ]), contentList = _ref.contentList, images = _ref.images, cardContent = _ref.contentModules, text = _ref.text, title1 = _ref.title, rest = (0,_object_without_properties/* default */.Z)(_ref, [
            "contentList",
            "images",
            "contentModules",
            "text",
            "title"
        ]);
        var image1 = (0,helper/* getImage */.gJ)(get_default()(images, "[0]"));
        var icon = get_default()(contentList, "[0]");
        var url = get_default()(cardContent, "[0].fields.url");
        var children = /*#__PURE__*/ (0,jsx_runtime.jsx)(containers_Overlay, {
            className: (CardsSection_module_default()).overlay,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card["default"], {
                title: title1,
                text: text
            })
        });
        return (0,_object_spread/* default */.Z)({
            url: url,
            image: image1,
            icon: icon,
            text: text,
            title: title1,
            children: children
        }, rest);
    };
};
/* harmony default export */ function useCardsSection(_param) {
    var section = _param.section, type = _param.type, sectionWithSlider = _param.withSlider, withOverlay = _param.withOverlay, data = _param.data, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "section",
        "type",
        "withSlider",
        "withOverlay",
        "data"
    ]);
    var ref, ref1, ref2, ref3;
    var ref4 = (0,helper/* getDocumentFields */.OA)(data || section, [
        "title",
        "description",
        "contentModules",
        "subtitle",
        "view",
        "images", 
    ], {
        isNormilized: data && !Object.keys(data).includes("fields") || section && !Object.keys(section).includes("fields")
    }), title = ref4.title, description = ref4.description, subtitle = ref4.subtitle, view = ref4.view, contentModules = ref4.contentModules, rawImages = ref4.images;
    var ref5 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", []), [
        "contentModules",
        "withoutBackground",
        "disableSliderOnMobile",
        "enableSliderOnDesktop", 
    ]), rawCardList = ref5.contentModules, withoutBackground = ref5.withoutBackground, disableSliderOnMobile = ref5.disableSliderOnMobile, enableSliderOnDesktop = ref5.enableSliderOnDesktop;
    var images = (rawImages || []).map(function(rawImage) {
        return (0,helper/* getImage */.gJ)(rawImage);
    });
    var cardList = (rawCardList || []).map(cardMapper(withOverlay));
    var ctaLink = get_default()(contentModules, "[1]");
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var isTabletResolution = (0,es.useSelector)(layout/* selectIsTablet */.aT);
    var IsFullResolution = (0,es.useSelector)(layout/* selectIsDesktop */.Y6);
    var withSlider = sectionWithSlider || enableSliderOnDesktop || !disableSliderOnMobile && (isTabletResolution || isMobileResolution);
    var isShowNavigation = enableSliderOnDesktop || !(IsFullResolution && (cardList === null || cardList === void 0 ? void 0 : cardList.length) <= 3);
    var swiperProps = {
        modules: [
            swiper_esm/* Navigation */.W_,
            swiper_esm/* Mousewheel */.Gk
        ],
        slidesPerView: 1,
        spaceBetween: ((ref = SPACE_BETWEEN[type]) === null || ref === void 0 ? void 0 : ref[view]) || 32,
        centeredSlides: true,
        autoHeight: false,
        passiveListeners: true,
        rewind: ((ref1 = REWIND[type]) === null || ref1 === void 0 ? void 0 : ref1[view]) || false,
        mousewheel: {
            forceToAxis: true
        },
        breakpoints: {
            768: {
                slidesPerView: ((ref2 = SLIDES_PER_VIEW[type]) === null || ref2 === void 0 ? void 0 : ref2[view]) || 2,
                centeredSlides: false
            },
            1024: {
                slidesPerView: ((ref3 = SLIDES_PER_VIEW[type]) === null || ref3 === void 0 ? void 0 : ref3[view]) || 3,
                centeredSlides: false
            }
        }
    };
    var className = classnames_default()((CardsSection_module_default()).cardsSection, (CardsSection_module_default())[type], (CardsSection_module_default())[view], (0,_define_property/* default */.Z)({}, (CardsSection_module_default()).withSlider, withSlider));
    return (0,_object_spread/* default */.Z)({
        type: type,
        view: view,
        withSlider: withSlider,
        cardList: cardList,
        ctaLink: ctaLink,
        title: title,
        description: description,
        subtitle: subtitle,
        className: className,
        withoutBackground: withoutBackground,
        swiperProps: swiperProps,
        withOverlay: withOverlay,
        isShowNavigation: isShowNavigation,
        images: images
    }, rest);
};

;// CONCATENATED MODULE: ./UI/sections/CardsSection/index.jsx












var CardsSection_Card = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 16921));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16921)
            ];
        }
    }
});
var CallToAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 92093).then(__webpack_require__.bind(__webpack_require__, 49617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49617)
            ];
        }
    }
});
var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Illustration = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
var CustomSwiper = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 33051).then(__webpack_require__.bind(__webpack_require__, 33051));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33051)
            ];
        }
    },
    ssr: false
});
var CardsSection = function(props) {
    var ref = useCardsSection(props), title = ref.title, subtitle = ref.subtitle, description = ref.description, cardList = ref.cardList, ctaLink = ref.ctaLink, withSlider = ref.withSlider, className = ref.className, handleOnCTAClick = ref.handleOnCTAClick, withoutBackground = ref.withoutBackground, withOverlay = ref.withOverlay, swiperProps = ref.swiperProps, isShowNavigation = ref.isShowNavigation, images = ref.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CardsSection_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                    title: title,
                    subtitle: subtitle,
                    description: description,
                    className: (CardsSection_module_default()).title
                }),
                withSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSwiper, {
                    className: (CardsSection_module_default()).swiperList,
                    swiperParams: swiperProps,
                    isShowNavigation: isShowNavigation,
                    navigationClassName: (CardsSection_module_default()).navigation,
                    children: cardList.map(function(card, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection_Card, (0,_object_spread/* default */.Z)({
                                className: classnames_default()((CardsSection_module_default()).card, (CardsSection_module_default())["card-".concat(i + 1)]),
                                withoutBackground: withoutBackground
                            }, card))
                        }, i);
                    })
                }),
                !withSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CardsSection_module_default()).cardList,
                    children: cardList.map(function(card, i) {
                        return /*#__PURE__*/ (0,react.createElement)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                            delay: 50 * i,
                            key: "card/".concat(i)
                        }), /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection_Card, (0,_object_spread/* default */.Z)({
                            className: classnames_default()((CardsSection_module_default()).card, (CardsSection_module_default())["card-".concat(i + 1)], (0,_define_property/* default */.Z)({}, (CardsSection_module_default()).withOverlay, withOverlay)),
                            withoutBackground: withoutBackground
                        }, card), i));
                    })
                }),
                !!images.length && images.map(function(image) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {
                        src: image.url,
                        className: (CardsSection_module_default()).image
                    }, image.url);
                }),
                ctaLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                        data: ctaLink,
                        handleOnClick: handleOnCTAClick,
                        className: (CardsSection_module_default()).callToAction
                    })
                }))
            ]
        })
    });
};
/* harmony default export */ var sections_CardsSection = (CardsSection);


/***/ }),

/***/ 92870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74129);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40659);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96076);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var UI_components_Media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34190);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69123);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);













var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var GalleryCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 34378).then(__webpack_require__.bind(__webpack_require__, 34378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34378)
            ];
        }
    }
});
var ArticleLink = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7002).then(__webpack_require__.bind(__webpack_require__, 7002)).then(function(module) {
        return module.ArticleLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7002)
            ];
        }
    }
});
var Table = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 84059).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var EmbedArticleCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 80931).then(__webpack_require__.bind(__webpack_require__, 80931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80931)
            ];
        }
    }
});
var Illustration = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 93812).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
// TODO move it to the common folder
// TODO create constants for cases
var ContentfulParser = function(param) {
    var document = param.document, linkIcon = param.linkIcon;
    var _obj, _obj1;
    var options = {
        renderMark: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.CODE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sub", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.BOLD, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.ITALIC, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.UNDERLINE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                children: node
            });
        }), _obj),
        renderNode: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var id = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target.sys.contentType.sys.id", "");
            switch(id){
                case "image":
                    {
                        var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", ""), [
                            "articleSingleImageType",
                            "image",
                            "title"
                        ]), articleSingleImageType = ref.articleSingleImageType, rawImage = ref.image, title = ref.title;
                        var image = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getImage */ .gJ)(rawImage);
                        var _obj;
                        return articleSingleImageType && image.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imageWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().normalImage), articleSingleImageType === "normal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fullImage), articleSingleImageType !== "normal"), _obj)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, {
                                        type: utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Illustration, {
                                            src: image.url,
                                            alt: image.alt,
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                                        })
                                    }),
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().photoCaption),
                                        children: title
                                    })
                                ]
                            })
                        });
                    }
                case "articleGalleryCard":
                    {
                        var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "images",
                            "photoCaption"
                        ]), images = ref1.images, photoCaption = ref1.photoCaption;
                        return images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryCard, {
                            images: images,
                            photoCaption: photoCaption
                        });
                    }
                case "link":
                    {
                        var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref2 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data, [
                            "title",
                            "buttonTitle",
                            "slug",
                            "type",
                            "url",
                            "new", 
                        ]), title1 = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug, type = ref2.type, url = ref2.url, isNew = ref2.new;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleLink, {
                            data: data,
                            new: isNew,
                            title: title1,
                            buttonTitle: buttonTitle,
                            slug: slug,
                            type: type,
                            url: url,
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().videoSection)
                        });
                    }
                case "table":
                    {
                        var ref3 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "tableContent",
                            "tableType"
                        ]), tableContent = ref3.tableContent, tableType = ref3.tableType;
                        return tableContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Table, {
                            tableData: tableContent.tableData,
                            type: tableType
                        });
                    }
                case "article":
                    {
                        var data1 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedArticleCard, {
                            data: data1
                        });
                    }
                case "text":
                    {
                        var data2 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref4 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data2, [
                            "text",
                            "id"
                        ]), text = ref4.text, entryId = ref4.id;
                        return(// eslint-disable-next-line react/no-unknown-property
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "grid-area": entryId,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulParser, {
                                document: text
                            })
                        }));
                    }
                default:
                    return null;
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
            return(// eslint-disable-next-line react/no-unknown-property
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "grid-area": "asset",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Media__WEBPACK_IMPORTED_MODULE_10__["default"], {
                    asset: data
                })
            }));
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().quote),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h3),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ul),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                type: "1",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ol),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
            var uri = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.uri", "/");
            var isInternalLink = uri.includes(utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .rootUrl */ .Wd);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                path: uri,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().a),
                isLocalLink: isInternalLink,
                children: [
                    children,
                    linkIcon
                ]
            });
        }), _obj1)
    };
    return document ? (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .documentToReactComponents */ .h)(document, options) : "";
};
ContentfulParser.defaultProps = {
    document: null
};
ContentfulParser.propTypes = {
    document: prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["default"] = (ContentfulParser);


/***/ }),

/***/ 93856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__msYo3","image":"Card_image__lDcsK","withoutBackground":"Card_withoutBackground__W7fGZ","title":"Card_title__3oNoL","withLink":"Card_withLink__QI1Gl","icon":"Card_icon__bKpvu","content":"Card_content__amq2q","cardContent":"Card_cardContent__g4BWE"};

/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 6992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__NnBr_","video-container":"styles_video-container__3YIN0","play-button":"styles_play-button__ubn_b"};

/***/ }),

/***/ 89494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleContainer":"styles_sectionTitleContainer__YEeiB","title":"styles_title__m075V","subtitle":"styles_subtitle__2fL8O","description":"styles_description__WuHDh","default":"styles_default__R0jjX","side":"styles_side___qNH3"};

/***/ }),

/***/ 14910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__GnP7H","noBackground":"CardContainer_noBackground__jHEZf","sb_cardWithOverlay":"CardContainer_sb_cardWithOverlay__guDiR","overlay":"CardContainer_overlay__xSItN"};

/***/ }),

/***/ 44291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__5DSjH"};

/***/ }),

/***/ 16161:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"CardsSection_cardsWithFullWidthImage__zdiiy","cards":"CardsSection_cards__Xu1aj","imageWrapper":"CardsSection_imageWrapper__E14c7","typeTitle":"CardsSection_typeTitle__umrvG","greySection":"CardsSection_greySection__VPrk_","natural-language-processing-as-a-service":"CardsSection_natural-language-processing-as-a-service__zSp2l","fourthSectionView":"CardsSection_fourthSectionView__QyB8v","ai-consulting-services":"CardsSection_ai-consulting-services__ijFzE","thirdSectionView":"CardsSection_thirdSectionView__VDnBT","firstSectionView":"CardsSection_firstSectionView__4VK2e","deep-learning":"CardsSection_deep-learning__BL3fw","generative-AI-services":"CardsSection_generative-AI-services__UlY8x","book-a-call":"CardsSection_book-a-call__P_xEY","billing-software-development-services":"CardsSection_billing-software-development-services__pH_Ua","secondSectionView":"CardsSection_secondSectionView__nVuyi","software-quality-assurance-services":"CardsSection_software-quality-assurance-services__ojOoL","seventhSectionView":"CardsSection_seventhSectionView__ommtO","sixthSectionView":"CardsSection_sixthSectionView__2aRkm","fifthSectionView":"CardsSection_fifthSectionView__CmnNj","payment-gateway-development-company":"CardsSection_payment-gateway-development-company__U0yuY","crowdfunding-platform-development-company":"CardsSection_crowdfunding-platform-development-company__H7mA8","penetration-testing":"CardsSection_penetration-testing__OPuIw","trading-software-development":"CardsSection_trading-software-development__PqfXN","lending-software-development":"CardsSection_lending-software-development__NToNB","prototyping-services":"CardsSection_prototyping-services__7RMgf","cross-platform-development-services":"CardsSection_cross-platform-development-services__RK6T4","cardsSection":"CardsSection_cardsSection__4tbF6","data-science-development-company":"CardsSection_data-science-development-company__RTwc9","web-app-development-company":"CardsSection_web-app-development-company__hV7id","ui-ux-services":"CardsSection_ui-ux-services__aosV_","mvp-app-development-company":"CardsSection_mvp-app-development-company__7f6yC","mobile-app-development-company":"CardsSection_mobile-app-development-company__MAChc","machine-learning-development-services":"CardsSection_machine-learning-development-services__TNMF_","ios-mobile-app-development-services":"CardsSection_ios-mobile-app-development-services__7G_Sl","fintech-software-development-services":"CardsSection_fintech-software-development-services__NPmkl","enterprise-resource-planning-software-services":"CardsSection_enterprise-resource-planning-software-services__UvLz7","discovery-phase-services":"CardsSection_discovery-phase-services__q7eTt","devops-development-services":"CardsSection_devops-development-services__xsFZn","cloud-based-app-development-services":"CardsSection_cloud-based-app-development-services__wit78","chat-app-development-company":"CardsSection_chat-app-development-company__Z_bop","artificial-intelligence-development-services":"CardsSection_artificial-intelligence-development-services__lIgpX","android-mobile-app-development-services":"CardsSection_android-mobile-app-development-services__G_iyX","callToAction":"CardsSection_callToAction__7jwDj","threeColumnsCards":"CardsSection_threeColumnsCards__iVFfi","healthcare-software-development-services":"CardsSection_healthcare-software-development-services__wPpT_","cardList":"CardsSection_cardList__RfzYT","entertainment-software-development-services":"CardsSection_entertainment-software-development-services__d8qpQ","educational-software-development-services":"CardsSection_educational-software-development-services__dR8Ao","travel-and-hospitality-software-development":"CardsSection_travel-and-hospitality-software-development__SBRqC","robotic-process-automation-services":"CardsSection_robotic-process-automation-services__TCa46","e-commerce-development":"CardsSection_e-commerce-development__Cx8Uf","logistics-software-development-services":"CardsSection_logistics-software-development-services__PG2Oc","software-development-services-for-various-industries":"CardsSection_software-development-services-for-various-industries__BmonE","software-development-services-for-tech-businesses":"CardsSection_software-development-services-for-tech-businesses__at2Qd","digital-wallet-for-ios":"CardsSection_digital-wallet-for-ios__AqUPb","clairvoyant-directory-upgrade":"CardsSection_clairvoyant-directory-upgrade__VxjGC","software-development-columbus":"CardsSection_software-development-columbus__JteBr","software-development-new-orleans":"CardsSection_software-development-new-orleans__x3fRz","software-development-tulsa":"CardsSection_software-development-tulsa__RLB3i","software-development-miami":"CardsSection_software-development-miami__FpOOu","software-development-minneapolis":"CardsSection_software-development-minneapolis__ENGlQ","software-development-omaha":"CardsSection_software-development-omaha__3gdbd","software-development-washington":"CardsSection_software-development-washington__Egyr1","software-development-oklahoma":"CardsSection_software-development-oklahoma__9r_Qz","software-development-nashville":"CardsSection_software-development-nashville__OWpgb","software-development-raleigh":"CardsSection_software-development-raleigh__N8n8v","crowdfunding-platform":"CardsSection_crowdfunding-platform__lmsT_","mobile-bank-application":"CardsSection_mobile-bank-application__Pz5fs","banking-software-development-company":"CardsSection_banking-software-development-company__A2tE9","e-wallet-app-development":"CardsSection_e-wallet-app-development__rAHtO","eighthSectionView":"CardsSection_eighthSectionView__vsF_M","pricing":"CardsSection_pricing__K4dox","twoColumnsCards":"CardsSection_twoColumnsCards__PWq94","textContent":"CardsSection_textContent__os1cn","cardWithFullSizeImage":"CardsSection_cardWithFullSizeImage__VDwQF","card":"CardsSection_card__CPc_I","blackSection":"CardsSection_blackSection__OvRHP","title":"CardsSection_title__WS_CJ","cardWithVerticalLine":"CardsSection_cardWithVerticalLine__ePRFX","overlay":"CardsSection_overlay__ekBI0","withOverlay":"CardsSection_withOverlay__GfGjt","contentWrapper":"CardsSection_contentWrapper__cfk_V","cardWithTransperentBackground":"CardsSection_cardWithTransperentBackground___W6E_","software-development-services-for-startups":"CardsSection_software-development-services-for-startups__2FQnW","cardContent":"CardsSection_cardContent__SL1Y3","navigation":"CardsSection_navigation__NyjAb","homepage":"CardsSection_homepage__KPskv","content":"CardsSection_content__oYPR0","swiper":"CardsSection_swiper__SK_5H","delivery-quality-in-yellow":"CardsSection_delivery-quality-in-yellow__Ci7eh","pwa-development-services":"CardsSection_pwa-development-services__Ug2rS","image":"CardsSection_image__s_aFw","card-1":"CardsSection_card-1__PNsBd","card-2":"CardsSection_card-2__udl4d","card-3":"CardsSection_card-3__nusab","company":"CardsSection_company__bp8ap","kitchen-equipment-customizer":"CardsSection_kitchen-equipment-customizer__Qm3wI","ai-software-development-services":"CardsSection_ai-software-development-services__tw3MO","computer-vision-services":"CardsSection_computer-vision-services__GqD6w","ai-mobile-cooking-app":"CardsSection_ai-mobile-cooking-app___oTD2","card-4":"CardsSection_card-4__sLdpk","card-5":"CardsSection_card-5__kT_Bo","card-6":"CardsSection_card-6__gn2pK","ai-chatbot-development-services":"CardsSection_ai-chatbot-development-services__oaP2l","ai-staff-augmentation-services":"CardsSection_ai-staff-augmentation-services__pORqg","ai-based-travel-planner":"CardsSection_ai-based-travel-planner__0I_mz","enhancing-money-laundering-mention-extraction":"CardsSection_enhancing-money-laundering-mention-extraction__8GfKS"};

/***/ }),

/***/ 69123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__BMuQY","h3":"styles_h3__wh4p0","paragraph":"styles_paragraph__9NG9P","a":"styles_a__QRxdK","ul":"styles_ul__esYyW","ol":"styles_ol__ue_m_","quote":"styles_quote___48vb","imageWrapper":"styles_imageWrapper__qFsnC","fullImage":"styles_fullImage__qANu4","normalImage":"styles_normalImage__eNnG6","image":"styles_image__Lejqj","photoCaption":"styles_photoCaption__WUS8x","videoSection":"styles_videoSection__g6E1A"};

/***/ })

}]);